import { render } from "./ContactUs.vue?vue&type=template&id=b7849fa4&scoped=true&bindings={}"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=b7849fa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b7849fa4"

export default script